import { render, staticRenderFns } from "./BlackListDetail.vue?vue&type=template&id=21884ddd&"
import script from "./BlackListDetail.vue?vue&type=script&lang=js&"
export * from "./BlackListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports